import { Controller } from "stimulus"

const DEFAULTS = {
  dominant: "#002142",
  title: "#002142",
  bar: "#FFC83C"
}

export default class extends Controller {
  static targets = [
    "dominantInput", "titleInput", "barInput",
    "headerBand", "headerText",
    "previewBar", "previewTitle",
    "ambianceSwatch", "ambianceHex"
  ]

  connect() {
    this.update()
  }

  update() {
    const dominant = this.readColor(this.hasDominantInputTarget && this.dominantInputTarget, DEFAULTS.dominant)
    const title = this.readColor(this.hasTitleInputTarget && this.titleInputTarget, DEFAULTS.title)
    const bar = this.readColor(this.hasBarInputTarget && this.barInputTarget, DEFAULTS.bar)
    const contrast = this.contrast(dominant)

    if (this.hasHeaderBandTarget) this.headerBandTarget.style.backgroundColor = dominant
    this.headerTextTargets.forEach((el) => (el.style.color = contrast))
    if (this.hasPreviewBarTarget) this.previewBarTarget.style.backgroundColor = bar
    if (this.hasPreviewTitleTarget) this.previewTitleTarget.style.color = title
    if (this.hasAmbianceSwatchTarget) this.ambianceSwatchTarget.style.backgroundColor = dominant
    if (this.hasAmbianceHexTarget) this.ambianceHexTarget.textContent = dominant
  }

  resetDominant(event) { this.resetInput(event, this.dominantInputTarget, DEFAULTS.dominant) }
  resetTitle(event) { this.resetInput(event, this.titleInputTarget, DEFAULTS.title) }
  resetBar(event) { this.resetInput(event, this.barInputTarget, DEFAULTS.bar) }

  resetInput(event, input, value) {
    event.preventDefault()
    input.value = value
    input.dispatchEvent(new Event("input", { bubbles: true }))
    input.dispatchEvent(new Event("change", { bubbles: true }))
  }

  readColor(input, fallback) {
    const raw = (input && input.value || "").trim()
    if (!/^#?(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(raw)) return fallback

    let hex = raw.startsWith("#") ? raw : `#${raw}`
    if (hex.length === 4) hex = `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`
    return hex.toUpperCase()
  }

  contrast(hex) {
    const h = hex.replace("#", "")
    const r = parseInt(h.slice(0, 2), 16)
    const g = parseInt(h.slice(2, 4), 16)
    const b = parseInt(h.slice(4, 6), 16)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
    return luminance > 0.62 ? "#002142" : "#FFFFFF"
  }
}
